import React from 'react';
import { IconProps } from './icons.models';

const UnlockIcon: React.FC<IconProps> = ({
    width = 44,
    height = 44,
    className,
    onClick,
    fillColor,
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1_32983)">
                <path d="M21.7568 0C15.7519 0.00689511 10.8858 4.55679 10.8784 10.1715V17.4054C10.8784 17.5975 11.5041 17.4054 11.9663 17.4054H15.2298C15.6919 17.4054 15.8993 17.6654 15.8993 17.4054V10.1715C15.8992 7.14664 18.5218 4.69454 21.7568 4.69454C24.9918 4.69454 27.6144 7.14664 27.6144 10.1715V13.3013C27.6144 13.7334 27.9891 14.0837 28.4512 14.0837H31.7984C32.2605 14.0837 32.6352 13.7334 32.6352 13.3013V10.1715C32.6278 4.55679 27.7616 0.00689511 21.7568 0Z" fill={fillColor ?? "#455A64"} />
                <path d="M11.0062 17.4062H32.507C34.9809 17.4062 36.9863 19.4936 36.9863 22.0684V38.8521C36.9863 41.4271 34.9809 43.5144 32.507 43.5144H11.0062C8.53231 43.5144 6.52686 41.4271 6.52686 38.8522V22.0685C6.52686 19.4936 8.53231 17.4062 11.0062 17.4062Z" fill={fillColor ?? "#FFC107"} />
                <path d="M26.1079 28.0248C26.1181 25.7748 24.1781 23.9431 21.775 23.9336C19.3718 23.9242 17.4154 25.7404 17.4053 27.9904C17.3983 29.5457 18.3376 30.9689 19.8263 31.6588L19.1545 36.0587C19.0872 36.5043 19.4184 36.9166 19.8943 36.9796C19.9346 36.9849 19.9753 36.9876 20.016 36.9876H23.4971C23.9778 36.992 24.3712 36.6309 24.3759 36.1809C24.3763 36.14 24.3735 36.0992 24.3673 36.0587L23.6955 31.6588C25.1663 30.9692 26.0986 29.5647 26.1079 28.0248Z" fill={fillColor ?? "#455A64"} />
            </g>
            <defs>
                <clipPath id="clip0_1_32983">
                    <rect width="43.5135" height="43.5135" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default UnlockIcon;


